export default "__VITE_ASSET__BrNO2dV4__"